"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.totalConversions = void 0;
const helper_1 = require("./helper");
const totalConversions = (dateRange, filters) => (0, helper_1.getMetricQuery)(['Conversions.count'], dateRange, [
    ...filters,
    {
        member: 'Conversions.positiveConversionCredit',
        operator: 'equals',
        values: ['true'],
    },
], undefined, undefined, undefined, 'Conversions.conversionTime');
exports.totalConversions = totalConversions;
//# sourceMappingURL=totalConversions.js.map